import styled from 'styled-components';
import Button from 'syf-component-library/ui/atoms/Button';
import query from 'syf-component-library/const/mediaQueries';
export const VerifyLinkTextWrapper = styled.span `
  display: inline-block;
  font-weight: normal;
  font-size: 14px;
  @media ${query.lessThanSmall} {
    max-width: 100%;
  }
`;
export const VerifyUserButton = styled(Button) `
  padding: 0;
  margin: 0;
  width: fit-content;
  height: auto;
  display: inline-block;
  text-align: inherit;
`;
